import { Injectable } from '@angular/core';
import { PrifactRoute } from '../../models/prifact-route';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {

  constructor() { }

  private routeHistory: Array<PrifactRoute> = [];

  public clearHisory() {
    this.routeHistory = [];
  }

  public addHistory(route: PrifactRoute) {
    this.routeHistory.push(route);
  }

  public pop(): PrifactRoute {
    return this.routeHistory.pop();
  }

  public getLength(): number {
    return this.routeHistory.length;
  }
}
